var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        staticClass: "login"
    }, [
        _c('p', [
            _vm._v("Número de móvil")
        ]),
        _c('br'),
        _c(_setup.AdvancedLoginForm, {
            ref: "form",
            attrs: {
                "autocomplete": false,
                "agreed": _setup.agreed
            },
            on: {
                "finished": _setup.onLoginFinished
            }
        }),
        _c('br'),
        _c('van-button', {
            staticStyle: {
                "height": "40px",
                "border-radius": "5px"
            },
            attrs: {
                "square": "",
                "type": "primary"
            },
            on: {
                "click": function($event) {
                    var _setup_form;
                    (_setup_form = _setup.form) === null || _setup_form === void 0 ? void 0 : _setup_form.submit();
                }
            }
        }, [
            _vm._v(" Entregar ")
        ]),
        _c('br'),
        _c('br'),
        _c(_setup.RegisterPrivacyCheckbox, {
            model: {
                value: _setup.agreed,
                callback: function callback($$v) {
                    _setup.agreed = $$v;
                },
                expression: "agreed"
            }
        })
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
